module.exports = __webpack_public_path__ + "static/media/mozza_bogo-mb-en.b5fde131.jpg";